import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import withFormGroup from "../../../modules/commons/withFormGroup";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import { ACTIVITY_TYPE } from "../../common/Constants";
import { mapToObjectDDL } from "../../common/mapper";

class MasterSamsatModifying extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cabangOptions: [],
    };
  }

  async componentDidMount() {
    const response = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
    if (response.ok && !R.isEmpty(response.data.data)) {
      this.setState((prevValue) => ({
        ...prevValue,
        cabangOptions: response.data.data.map((c) => mapToObjectDDL(c.namaDealer, c.kodeCabang)),
      }));
    }
  }

  handleSubmit = () => {
    if (this.props.validate()) {
      this.props.onSubmit(this.props.controls);
    }
  };

  getDataValue = (fieldName, fallbackValue = "") => {
    return !R.isNil(this.props.state.filterData) && this.props.state.filterData[fieldName]
      ? this.props.state.filterData[fieldName]
      : fallbackValue;
  };

  render() {
    return (
      <SimpleModal
        title="Form Data Samsat"
        visible={this.props.visible}
        onClickClose={this.props.onClickClose}
        content={
          <ModalContainer>
              <SimpleInput
                id="input_text_id"
                name="samsatId"
                label="ID"
                readOnly={R.equals(this.props.activityType, ACTIVITY_TYPE.UPDATE)}
                mandatory
                errorMessage={this.props.errors.samsatId}
                value={this.props.controls.samsatId.value}
                onChange={({ target }) => this.props.setValue(target.name, target.value)}
              />
              <SimpleInput
                id="input_text_nama_samsat"
                name="samsatName"
                label="Nama Samsat"
                mandatory
                errorMessage={this.props.errors.samsatName}
                value={this.props.controls.samsatName.value}
                onChange={({ target }) => this.props.setValue(target.name, target.value)}
              />
              <SimpleDDL
                id="select_options_oleh_cabang"
                name="listCabang"
                label="Diakses Cabang"
                box="multiselect"
                mandatory
                errorMessage={this.props.errors.listCabang}
                options={this.state.cabangOptions}
                value={this.props.controls.listCabang.value}
                onChange={(value, { name }) => this.props.setValue(name, value)}
              />
              <FlexView hAlignContent="center">
                <SimpleButton type="button" secondary onClick={this.props.reset}>
                  Hapus
                </SimpleButton>
                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
              </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default withFormGroup(MasterSamsatModifying);
